import { AccountGroup } from '../../../core/model/account-group/account-group.model';

/**
 * Function fills id parameter for every AccountGroup in the input array, so it can be distinguished from others.
 * Id is composed from name and random integer.
 */
export function addIdsToAccountGroups(accountGroups: AccountGroup[]): void {
    accountGroups.forEach((elem: AccountGroup) => {
        elem.id = elem.name + (Math.random() * 100000).toString();
    });
    return;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/helper/account-group-id-adder.helper.ts